module.exports = __webpack_public_path__ + "static/media/at.67c731e9.svg";